import type { PaymentsStore } from '@stores/payments/interfaces'

const setMerchantData = (state: PaymentsStore, payload: PaymentsStore['merchantData']): void => {
  state.merchantData = payload
}

export const actions = {
  setPaymentMethodsLoading (this: PaymentsStore, payload: PaymentsStore['paymentMethodsLoading']): void {
    this.paymentMethodsLoading = payload
  },
  setPaymentMethodsListLoading (this: PaymentsStore, payload: PaymentsStore['paymentMethodsListLoading']): void {
    this.paymentMethodsListLoading = payload
  },
  setPaymentMethods (this: PaymentsStore, payload: PaymentsStore['paymentMethods']): void {
    this.paymentMethods = payload
  },
  setPaymentMethodsClear (this: PaymentsStore): void {
    this.paymentMethods = []
  },
  setSubscriptionsLoading (this: PaymentsStore, payload: PaymentsStore['subscriptionsLoading']): void {
    this.subscriptionsLoading = payload
  },
  setSubscriptions (this: PaymentsStore, payload: PaymentsStore['subscriptions']): void {
    this.subscriptions = payload
  },
  setSubscriptionsClear (this: PaymentsStore): void {
    this.subscriptions = []
  },
  setModalChangeDefaultCreditCard (this: PaymentsStore, payload: PaymentsStore['modalChangeDefaultCreditCard']): void {
    this.modalChangeDefaultCreditCard = payload
  },
  setModalDeleteCreditCard (this: PaymentsStore, payload: PaymentsStore['modalDeleteCreditCard']): void {
    this.modalDeleteCreditCard = payload
  },
  setModalAddCreditCard (this: PaymentsStore, payload: PaymentsStore['modalAddCreditCard']): void {
    this.modalAddCreditCard = payload
  },
  setMerchantData (this: PaymentsStore, payload: PaymentsStore['merchantData']): void {
    setMerchantData(this, payload)
  },
  setStripeSetupSecret (this: PaymentsStore, payload: PaymentsStore['stripeSetupSecret']): void {
    this.stripeSetupSecret = payload
  },
  setModalAddCreditCardClose (this: PaymentsStore): void {
    this.modalAddCreditCard = false
    setMerchantData(this, null)
    this.stripeSetupSecret = null
  },
  setOrdersLoading (this: PaymentsStore, payload: PaymentsStore['ordersLoading']): void {
    this.ordersLoading = payload
  },
  setLoading (this: PaymentsStore, payload: PaymentsStore['loading']): void {
    this.loading = payload
  },
  setOrders (this: PaymentsStore, payload: PaymentsStore['orders']): void {
    this.orders = payload
  },
  setOrdersClear (this: PaymentsStore): void {
    this.orders = null
  },
  setModalRefund (this: PaymentsStore, payload: PaymentsStore['modalRefund']): void {
    this.modalRefund = payload
  },
}
